import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface TapeData {
  total_market_cap_usd: number;
  total_24h_volume_usd: number;
  bitcoin_percentage_of_market_cap: number;
  active_currencies: number;
  active_markets: number;
  btc_change_24h: number | null;
  eth_change_24h: number | null;
  market_pressure: string | null;
  source: string;
  generated_at: string;
  stale?: boolean;
}

async function fetchTape(): Promise<TapeData | null> {
  try {
    const { data, error } = await supabase.functions.invoke("fng-tape");
    if (error) return null;
    if (data?.error) return null;
    return data as TapeData;
  } catch {
    return null;
  }
}

export function useTape(enabled = true) {
  return useQuery({
    queryKey: ["fng-tape"],
    queryFn: fetchTape,
    staleTime: 30 * 60 * 1000, // 30 min
    refetchOnWindowFocus: false,
    enabled,
    retry: false,
  });
}
